import React, { useState } from 'react';

import { FormActions, FormBody, type TFormValue } from '@dashboard/components/form-fields/ContactsGroupDialogForm';
import { useContactsGroupsQuery, useCreateContactsGroupMutation } from '@dashboard/generated/wp/platform';
import usePlatformNavigator from '@dashboard/hooks/navigate/usePlatformNavigator';
import { AddOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';

import { alertError, alertSuccess } from '@waypoint/react/notifications';

export default function CreateTopicListDialog() {
  const [open, setOpen] = useState(false);
  const [triggerCreate, { loading }] = useCreateContactsGroupMutation();
  const { refetch } = useContactsGroupsQuery();
  const navigator = usePlatformNavigator();

  const onSubmit = async (formData: TFormValue) => {
    try {
      const { data } = await triggerCreate({ variables: formData });
      await refetch();
      if (data?.createContactsGroup.id) {
        navigator.showContactsGroup(data.createContactsGroup.id);
      }
      alertSuccess('Unsubscribe group added');
      onClose();
    } catch (e) {
      alertError('Failed to add an unsubscribe group');
    }
  };

  const onClose = () => setOpen(false);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<AddOutlined />}
        color="primary"
        onClick={() => setOpen(true)}
      >
        New
      </Button>

      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Add unsubscribe group</DialogTitle>
        <DialogContent>
          <FormBody
            initialValues={{
              name: '',
              key: '',
              unsubscribeLinkTemplate: '[Unsubscribe]({{unsubscribeUrl}}) from messages like these.',
              unsubscribePageTitleTemplate: 'Unsubscribe',
              unsubscribePageSubtitleTemplate: `Opt-out of '{{groupName}}' emails.`,
              unsubscribePageEmailInputLabelTemplate: 'Email address',
              unsubscribePageSubmitButtonLabelTemplate: 'Unsubscribe',
              unsubscribePageConfirmationMessageTemplate: `You're now unsubscribed`,
              unsubscribePageInvalidEmailAddressMessageTemplate: 'Invalid email address',
            }}
            onSubmit={onSubmit}
          />
        </DialogContent>
        <FormActions version="CREATE" loading={loading} onClose={onClose} />
      </Dialog>
    </>
  );
}
